<nav class="page-footer">
  <ng-content></ng-content>
</nav>
